"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _link = _interopRequireDefault(require("../link"));

var _user = require("./user.styles");

var _assertion = require("../utils/assertion");

var _jsxRuntime = require("react/jsx-runtime");

const UserLink = /*#__PURE__*/_react.default.forwardRef(({
  href,
  className,
  children,
  ...props
}, ref) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_user.StyledUserLink, { ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_link.default, {
      ref: ref,
      href: href,
      color: "primary",
      target: "_blank",
      rel: "noopener",
      children: children
    })
  });
});

if (_assertion.__DEV__) {
  UserLink.displayName = 'NextUI - UserLink';
}

UserLink.toString = () => '.nextui-user-link';

const MemoUserLink = /*#__PURE__*/_react.default.memo(UserLink);

var _default = MemoUserLink;
exports.default = _default;
module.exports = exports.default;